
/**
 * A hook that determines if a nav item's path matches the current location
 */
export const useNavItemPathMatching = (itemPath: string, currentPath: string): boolean => {
  // Exact match
  if (currentPath === itemPath) {
    return true;
  }
  
  // Special case for dashboard - handle multiple dashboard paths
  if ((itemPath === '/app/dashboard' || itemPath === '/dashboard' || itemPath === '/') && 
      (currentPath === '/app/dashboard' || currentPath === '/dashboard' || currentPath === '/')) {
    return true;
  }
  
  // Special case for leads - only match exact /app/leads, not sub-routes like /app/leads/contacts
  if (itemPath === '/app/leads') {
    return currentPath === '/app/leads';
  }
  
  // For other paths (excluding root paths), check if current path starts with item path
  if (itemPath !== '/' && itemPath !== '/dashboard' && itemPath !== '/app/dashboard' && itemPath !== '/app/leads') {
    // Handle path variations (with or without trailing slash)
    const normalizedItemPath = itemPath.endsWith('/') ? itemPath : `${itemPath}/`;
    const normalizedCurrentPath = currentPath.endsWith('/') ? currentPath : `${currentPath}/`;
    
    return normalizedCurrentPath.startsWith(normalizedItemPath) || 
           currentPath.startsWith(itemPath);
  }
  
  return false;
};
